import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_117: FaireProductEntity = {
  token: "legacy_prod_abbott-117",
  type: "product",
  name: "Beehive Honey Pot W Dauber-Wht",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/ab60cb7c2ef594021b5d227e52cf892ebfda38f8bb31f850ebc09c9a8d58f5f8.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
